import { SendEmailRequest, SendEmailResponse } from '../models/Email';
import { emailApiClient } from './emailApiClient';

interface ApiProblemDetails {
  detail?: string;
}

const postToEmailApi = async (path: string, payload: unknown): Promise<SendEmailResponse> => {
  const response = await emailApiClient(path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });

  if (!response.ok) {
    const errorBody = (await response.json().catch(() => undefined)) as ApiProblemDetails | undefined;
    // Only a 400's detail is written for agents (e.g. the email size limit); the status is logged by emailApiClient.
    throw new Error(
      response.status === 400 && errorBody?.detail ? errorBody.detail : 'Failed to send email. Please try again.'
    );
  }

  return (await response.json()) as SendEmailResponse;
};

export const sendEmail = async (payload: SendEmailRequest): Promise<SendEmailResponse> => postToEmailApi('', payload);
